exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".customer-document-list{margin-bottom:15px}.customer-document-list__title{font-size:14px;margin:5px 0 10px 5px;font-weight:600}.customer-document-list__item{background-color:var(--theme-grey-bg);border-bottom:1px solid #a0a4b0}.customer-document-list__type{font-size:12px}", ""]);

// exports
